/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetScheduleByUserModel,
  IGetScheduleByUserRequest,
  IMappers,
  IGetScheduleByUserResponse,
  IGetScheduleByUserResponseError,
  TGetScheduleByUserResponse,
} from './types';

const defaultConfig: TGetScheduleByUserModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'work-time',
  pathApi: '/v1/get-schedule-by-user/',
  hostType: 'api',
} as TGetScheduleByUserModel;

function createGetScheduleByUserModel(parameters: IGetScheduleByUserRequest): TGetScheduleByUserModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetScheduleByUserOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetScheduleByUserRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetScheduleByUser<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetScheduleByUserOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetScheduleByUserResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetScheduleByUserModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetScheduleByUserResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetScheduleByUserResponseError);
    }
  }

  return { response, statusCode } as TGetScheduleByUserResponse;
}

export { defaultConfig, createGetScheduleByUserModel, fetchGetScheduleByUser };
